import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const getToken = Cookies?.get('token');

if (!getToken) {
  window.location.href = process.env.REACT_APP_PRODUCTION_URL;
}

let employeeId = '';
let roleName = '';
let employeeName = '';

try {
  if(getToken){
    const decodedToken = jwtDecode(
      getToken,
      process.env.REACT_APP_JWT_SECRET_KEY
    );

  // const decodedToken = {
  //   employeeNo: 'SPAN-BLR-2145',
  //   name: 'Ayush Singhal',
  //   isAdmin: false,
  //   email: 'ayushs@spanidea.com',
  //   portalAccess: [
  //     {
  //       roleName: 'Admin',
  //       portalName: 'CMS',
  //     },
  //   ],
  //   timesheetDeliveryManager: false,
  //   iat: 1726139358,
  //   exp: 1727003358,
  // };

  employeeId = decodedToken?.employeeNo;
  employeeName = decodedToken?.name;

  const listOfPortalName = decodedToken?.portalAccess;

  if (decodedToken?.isAdmin) {
    roleName = 'Admin';
  } else if (
    !decodedToken?.isAdmin &&
    !listOfPortalName.some((role) => role.portalName === 'CMS')
  ) {
    window.location.href = process.env.REACT_APP_PRODUCTION_URL;
  } else {
    roleName = listOfPortalName.find(
      (role) => role.portalName === 'CMS'
    ).roleName;
  }
  } else {
    window.location.href = process.env.REACT_APP_PRODUCTION_URL;
  }
} catch (error) {
  console.log(error);
  window.location.href = process.env.REACT_APP_PRODUCTION_URL;
}

const GetRole = () => {
  if (roleName === 'Admin') {
    return 'admin';
  }
  if (roleName === 'Update') {
    return 'bdTeam';
  }
  if (roleName === 'View') {
    return 'finance';
  }
};

const userRole = GetRole();

export { userRole, employeeId, employeeName };
